import { createApi } from '@reduxjs/toolkit/query/react';

import {
  fetchWithAuthBaseQuery,
  validateAndTransformResponse,
} from '#shared/api';

import {
  simpleStatisticsResponseSchema,
  type SimpleStatisticsResponse,
} from './schemas';

const paths = {
  simpleStatistics: 'api/simpleStatistics',
} as const;

export const simpleStatisticsApi = createApi({
  reducerPath: 'simpleStatisticsApi',

  baseQuery: fetchWithAuthBaseQuery,
  refetchOnReconnect: true,
  endpoints: build => ({
    getSimpleStatistics: build.query({
      query: () => paths.simpleStatistics,
      transformResponse: (response: SimpleStatisticsResponse) =>
        validateAndTransformResponse(
          simpleStatisticsResponseSchema,
          response,
          undefined,
          'simpleStatistics',
        ),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetSimpleStatisticsQuery } = simpleStatisticsApi;
